(function () {
  "use strict";

  logoResource.$inject = ['$resource', 'errorHandler'];
  angular
    .module('branding')
    .factory('logoResource', logoResource);

  function logoResource($resource, errorHandler) {

    var logoResource = $resource(mfConfig.accountBaseUrlSegment + '/logo');

    logoResource.prototype.create = function create(params, resultCb, errorCb) {
      return logoResource.save(params, resultCb || angular.noop, errorHandler.defaultServerErrorHandler(errorCb));
    };

    return new logoResource;
  }
})();
